import { render } from "./AttendanceEdit.vue?vue&type=template&id=ae315180&ts=true"
import script from "./AttendanceEdit.vue?vue&type=script&lang=ts"
export * from "./AttendanceEdit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__